import React, { useState, useEffect } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";

import CheckoutForm from "./CheckoutForm";
import SetupForm from "./setupForm";
import PaymentStatus from "./paymentStatus";

// Make sure to call loadStripe outside of a component’s render to avoid
// recreating the Stripe object on every render.
// This is your test publishable API key.

export default function StripeA({
  cardStorageOptions,
  setModalAddCustomerCard,
  setClientSecret,
}) {
  return (
    <div className={"stripe-container"}>
      <SetupForm
        setClientSecret={setClientSecret}
        cardStorageOptions={cardStorageOptions}
        setModalAddCustomerCard={setModalAddCustomerCard}
      />
      <PaymentStatus />
    </div>
  );
}
